import * as React from 'react';
import { type RecoveryChildrenProps } from '@shared/components/Recovery';

type ContextType = Partial<RecoveryChildrenProps<any>>;

export const context = React.createContext<ContextType>({});

export interface ProviderProps extends ContextType {
  children?: React.ReactNode;
}

const Provider = (props: ProviderProps) => {
  const { children, ...rest } = props;

  return <context.Provider value={rest}>{children}</context.Provider>;
};

export default Provider;

export const useEditingContext = () => React.useContext(context);
